var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-router",class:{ visible: _vm.isVisible },on:{"click":_vm.onClickRouter}},[_c('div',{staticClass:"view-router-indicator"}),_c('div',{staticClass:"view-router-title"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }